<template>
  <div class=" items-stretch h-full">

    <CreateOrEditCategory ref="category"/>

    <div class="flex justify-between w-full">

      <div class="">
        <div id="categories-place-label" class="sr-only">Prevádzka</div>
        <SelectButton v-model="restaurantPlace"
                      :options="RESTAURANT_PLACES"
                      :allowEmpty="false"
                      aria-labelledby="categories-place-label"
                      size="small"
                      option-value="value"
                      optionLabel="name"
        />
      </div>
      <Button @click="openCategory(null)" size="small" label="Pridať" icon="pi pi-plus" iconPos="right"/>
    </div>

    <hr class="my-4">

    <div class="mt-4">
      <div v-for="category in filteredCategories" :key="category.id" class="flex space-x-2 mb-4">
        <div
             class="w-full bg-primary-600 text-white px-3 py-2 rounded-lg"
        >
          <div class="flex flex-wrap items-center justify-between gap-2 text-white">
            {{ category.name }}
            <div class="flex flex-wrap gap-2">
              <span v-if="(category.menuActive ?? category.active) === false"
                    class="rounded-full bg-red-950/35 px-2 py-1 text-xs font-medium">
                Neaktívna
              </span>
              <span class="rounded-full bg-white/15 px-2 py-1 text-xs font-medium">
                {{ orderVisibilityLabel(category.orderVisibility) }}
              </span>
            </div>
          </div>
        </div>
        <Button @click="openCategory(category)" icon="pi pi-cog" :aria-label="`Upraviť kategóriu ${category.name}`" class="rounded-lg"/>
      </div>
    </div>

  </div>
</template>

<script setup>
import {reactive, useTemplateRef, ref, onMounted, nextTick, computed} from 'vue'
import useContentStore from "@/stores/contentStore.js";
import CreateOrEditCategory, {openCategory} from "@/components/views/CreateOrEditCategory.vue";
import {RESTAURANT_PLACES} from "@/content/lists.js";
import {orderVisibilityLabel} from "@/utils/categoryVisibility.js";

const contentStore = useContentStore()
const category = ref()

const restaurantPlace = ref('BO')

const filteredCategories = computed(() => contentStore.appCategories.filter(category => category.restaurantPlace === restaurantPlace.value))


</script>
